module.exports = __webpack_public_path__ + "static/images/tutorial-4-ical.cf66ab1df3ea66619c09b865eb0735a8.svg";